import { request } from '@/restapi/restapi.base.js';

export function readAsArrayBuffer(file) {
    if (!(file instanceof File))
        throw new TypeError('Parameter is not an instance of File');

    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = function () {
            resolve(reader.result);
        };

        reader.onerror = function () {
            reject(reader.error);
        };

        reader.readAsArrayBuffer(file);
    });
}


/**
 * Сохранить Blob как файл
 */
export function saveBlob(filename, blob) {
    const URL = window.URL || window.webkitURL;
    const href = URL.createObjectURL(blob);
    const link = document.createElement('a');
    try {
        link.style = 'display: none;';
        link.download = filename;
        link.href = href;

        document.body.appendChild(link);

        link.click();

    } finally {
        link.remove();
        URL.revokeObjectURL(href);
    }
}


const fileFormat = [
    {
        size: 1,
        suff: 'б',
        zero: 0,
    }, {
        size: 1 << 10,
        suff: 'КБ',
        zero: 0,
    }, {
        size: 1 << 20,
        suff: 'МБ',
        zero: 2,
    }, {
        size: 1 << 30,
        suff: 'ГБ',
        zero: 2,
    },
];


export function formatFileSize(size, zero) {
    if (size == null)
        return '';

    let index = fileFormat.length;

    while (--index > 0) {
        if (size > fileFormat[index].size)
            break;
    }

    let info = fileFormat[index];

    return (size / info.size).toFixed(zero ?? info.zero) + ' ' + info.suff;
}


export function getFileName(name) {
    const index = name.lastIndexOf('.');
    if (index < 0) {
        return name;
    }
    return name.substr(0, index);
}


export function getFileType(name) {
    const part = name.match(/\.(\w+)$/);
    return part ? part[1].toLowerCase() : '';
}


export function documentsMap(documents = []) {
    return documents.map(it => ({ ...it.value, id: it.id }));
}


export function documentGroupsMap(documentGroups = []) {
    const documentGroupsMap = [];

    for (const it of documentGroups) {
        const groupData = it.value;
        const documents = groupData.documents?.map((doc) => doc.id) ?? [];

        documentGroupsMap.push({
            ...groupData,
            documents,
        });
    }

    return documentGroupsMap;
}

export function documentsAddAccessType(documents, accessType = '') {
    return documents.map((it) => ({
            accessType,
            ...it,
        }),
    );
}

export function documentGroupsAddAccessType(documentGroups, accessType = '') {
    return documentGroups.map((it) => ({
        accessType,
        ...it,
    }));
}


/**
 * Загрузка файла
 */
export async function downloadFileAs(url, filename, reqt, opts = {}) {
    const resp = await request(url, reqt, {
        responseType: 'blob',
        blocking: true,
        ...opts,
    });

    saveBlob(filename, resp);
}

/**
 * Скачать файл
 */
export async function downloadFile(id, reqt, opts = {}) {
    window.open('/api/file/load/' + id, '_blank');
}

/**
 * Получить файл
 */
export async function getFile(id, reqt, opts = {}) {
    const resp = await request('/api/file/load/' + id, reqt, {
        responseType: 'blob',
        method: 'GET',
        blocking: true,
        ...opts,
    });

    return resp;
}


/**
 * Получить только изменённые документы
 */
export function getDocumentChanged({ documents = [], documentGroups = [] }) {
    if (!documents?.length && !documentGroups?.length)
        return [];

    const documentUpdateInfo = documents.filter(doc => doc.edited === true);

    for (const group of documentGroups) {
        if (!group.value.documents)
            continue;

        const editDocs = group.value.documents.filter(doc => doc.edited === true);
        documentUpdateInfo.push(...editDocs);
    }

    return documentUpdateInfo;
}
